export default __webpack_public_path__ + "static/media/Bg-6.1c34d125.png";